import React, { FC } from 'react';
import { DatePicker as MuiDatePicker } from '@material-ui/pickers';
import { makeStyles, withStyles } from '@material-ui/core/styles';
import Icon from '../Icon';
import CalendarAlt from '../Icon/icons/outlined/calendar-alt';
import { DatePickerProps } from './types';
import styles, { DatePickerWrapper, IonwWrapper, popOverStyles, inputStyles } from './styles';

const StyledMuiDatePicker = withStyles(styles)(MuiDatePicker);
const usePopOverStyles = makeStyles(popOverStyles);
const useInputStyles = makeStyles(inputStyles);

const CommonDatePickerProps = {
  maxDateMessage: null,
  minDateMessage: null,
  inputVariant: 'outlined',
  disableToolbar: true,
  variant: 'inline',
  format: 'yyyy/MM/dd',
  autoOk: true,
} as const;

const DatePicker: FC<DatePickerProps> = ({
  value,
  onChange,
  placeholder,
  label,
  minDate,
  maxDate,
  disableFuture,
  disablePast,
  ...restProps
}) => {
  const inputClasses = useInputStyles();
  const popOverClasses = usePopOverStyles();
  const CommonDatePickerClassProps = {
    PopoverProps: {
      PaperProps: {
        classes: {
          root: popOverClasses.root
        }
      }
    }
  };

  const variantInputProps = {
    classes: {
      root: inputClasses.root,
    }
  };

  return (
    <DatePickerWrapper>
      <IonwWrapper>
        <Icon icon={CalendarAlt} />
      </IonwWrapper>
      <StyledMuiDatePicker
        value={value}
        onChange={onChange}
        placeholder={placeholder}
        label={label}
        minDate={minDate}
        maxDate={maxDate}
        disableFuture={disableFuture}
        disablePast={disablePast}
        InputProps={variantInputProps}
        {...restProps}
        {...CommonDatePickerProps}
        {...CommonDatePickerClassProps}
      />
    </DatePickerWrapper>
  );
};

export default DatePicker;
